module.exports = __webpack_public_path__ + "static/media/bg-sobre-pedraza.2c876d92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/sobrePedraza/bg-sobre-pedraza.jpg
// module id = 119
// module chunks = 0